import { Link } from 'react-router-dom';

const corsi = [
  {
    title: 'Portamento',
    subtitle: 'La Tua Prima Impressione',
    desc: 'Il portamento è la tua firma visiva. Impara a camminare, stare in piedi e muoverti con grazia, eleganza e consapevolezza del corpo. Una competenza che si porta nella vita di tutti i giorni.',
    image: 'https://public.readdy.ai/ai/img_res/af89b129ac3a4a3fef3204056ee9d932.jpg',
    items: ['Postura e allineamento', 'Tecnica del passo in passerella', 'Linguaggio del corpo', 'Presenza e sicurezza'],
  },
  {
    title: 'Modelling',
    subtitle: 'Dal Set alle Passerelle',
    desc: 'Scopri i segreti del modelling professionale: pose, espressioni, shooting fotografici e sfilate. Ti prepariamo con gli standard richiesti dalle agenzie e dai casting internazionali.',
    image: 'https://readdy.ai/api/search-image?query=professional%20model%20posing%20for%20fashion%20photo%20shoot%2C%20studio%20photography%20with%20dramatic%20golden%20lighting%2C%20editorial%20fashion%20pose%2C%20confident%20and%20glamorous%20expression%2C%20black%20background%20with%20golden%20highlights%2C%20high%20fashion%20editorial%20photography%2C%20luxury%20fashion%20shoot&width=600&height=800&seq=corso02&orientation=portrait',
    items: ['Posing per shooting fotografici', 'Tecniche di sfilata', 'Portfolio professionale', 'Casting e agenzie'],
  },
  {
    title: 'Recitazione',
    subtitle: 'La Tua Voce sul Palco',
    desc: 'Tecniche di recitazione professionali per libera la tua espressività. Dal monologo alla scena drammatica, lavoriamo su voce, corpo, emozioni e improvvisazione.',
    image: 'https://readdy.ai/api/search-image?query=young%20actor%20performing%20dramatic%20scene%20on%20stage%2C%20theatrical%20spotlight%2C%20emotional%20and%20expressive%20performance%2C%20professional%20theater%20production%2C%20dark%20stage%20with%20warm%20golden%20spotlight%2C%20arts%20and%20drama%2C%20cinematic%20acting%20scene%2C%20intense%20dramatic%20moment&width=600&height=800&seq=corso03&orientation=portrait',
    items: ['Metodi di recitazione', 'Improvvisazione', 'Lavoro sul testo', 'Voce e dizione'],
  },
  {
    title: 'Cinema',
    subtitle: 'Davanti alla Macchina da Presa',
    desc: 'Tecniche specifiche per il cinema: come comportarsi sul set, gestire le emozioni davanti alla telecamera, capire il copione e brillare nei provini. Il cinema è una disciplina unica.',
    image: 'https://readdy.ai/api/search-image?query=actor%20performing%20in%20front%20of%20professional%20movie%20camera%20on%20film%20set%2C%20cinema%20production%20studio%2C%20dramatic%20lighting%2C%20film%20set%20equipment%20with%20golden%20bokeh%20lights%2C%20cinematic%20atmosphere%2C%20professional%20movie%20production%2C%20artistic%20film%20photography&width=600&height=800&seq=corso04&orientation=portrait',
    items: ['Recitazione per la camera', 'Gestione del set', 'Provini cinematografici', 'Analisi del copione'],
  },
];

interface CorsiSectionProps {
  onCtaClick: () => void;
}

export default function CorsiSection({ onCtaClick }: CorsiSectionProps) {
  return (
    <section className="py-16 md:py-28 bg-black" id="corsi">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <span
            className="inline-block border border-yellow-600/60 text-yellow-500 text-xs tracking-widest uppercase px-5 py-2 rounded-full mb-6"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            I Nostri Corsi
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-white mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Formazione Completa{' '}
            <span style={{ color: '#D4AF37' }}>e Mirata</span>
          </h2>
          <p
            className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
          >
            Percorsi formativi pensati per chi ambisce a diventare modello, modella,
            attore o attrice. Ogni corso è seguito da professionisti del settore.
          </p>
        </div>

        {/* Grid Corsi */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {corsi.map((corso) => (
            <div
              key={corso.title}
              className="group relative rounded-xl overflow-hidden border border-yellow-600/20 hover:border-yellow-500/50 transition-all duration-500 hover:-translate-y-2"
              style={{ background: '#111' }}
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={corso.image}
                  alt={`Filmodeling - Corso ${corso.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div
                  className="absolute bottom-4 left-4 right-4"
                >
                  <div
                    className="text-xs tracking-widest uppercase mb-1"
                    style={{ fontFamily: "'Montserrat', sans-serif", color: '#D4AF37', fontWeight: 500 }}
                  >
                    {corso.subtitle}
                  </div>
                  <h3
                    className="text-2xl font-bold text-white"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {corso.title}
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p
                  className="text-gray-400 text-sm leading-relaxed mb-5"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  {corso.desc}
                </p>
                <ul className="space-y-2">
                  {corso.items.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-sm">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-right-s-line" style={{ color: '#D4AF37' }} />
                      </div>
                      <span
                        className="text-gray-300"
                        style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Bottom line on hover */}
              <div
                className="h-0.5 w-0 group-hover:w-full transition-all duration-500"
                style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}
              />
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div
          className="mt-14 md:mt-20 rounded-2xl p-6 md:p-14 text-center border"
          style={{
            borderColor: '#D4AF37',
            background: 'linear-gradient(135deg, #0d0d0d 0%, #1a1200 50%, #0d0d0d 100%)',
            boxShadow: '0 0 60px rgba(212,175,55,0.1)',
          }}
        >
          <h3
            className="text-2xl md:text-4xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Scopri quale percorso fa per te{' '}
            <span style={{ color: '#D4AF37' }}>all'Open Day</span>
          </h3>
          <p
            className="text-gray-400 mb-8 max-w-xl mx-auto text-sm leading-relaxed"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
          >
            Al Casting Open Day del 30 Marzo potrai incontrare i nostri insegnanti,
            fare un provino e capire quale corso è più adatto al tuo talento.
          </p>
          <button
            onClick={onCtaClick}
            className="w-full sm:w-auto bg-gradient-to-r from-yellow-700 to-yellow-500 text-black font-bold tracking-widest uppercase px-6 md:px-10 py-4 rounded-md text-xs md:text-sm hover:shadow-xl hover:shadow-yellow-700/40 hover:scale-105 transition-all duration-300 cursor-pointer flex items-center justify-center gap-2"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <span className="sm:hidden">Prenota il Posto Gratis</span>
            <span className="hidden sm:inline">Prenota il Tuo Posto Gratis</span>
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        {/* Footer */}
        <footer
          className="mt-24 pt-10 border-t flex flex-col md:flex-row items-center justify-between gap-6"
          style={{ borderColor: 'rgba(212,175,55,0.15)' }}
        >
          <div className="flex gap-6">
            {[
              { icon: 'ri-instagram-line', href: 'https://www.instagram.com/tennisclubpozzuoli?igsh=MTAxd21wNGdxbXBuNw==' },
              { icon: 'ri-facebook-circle-line', href: 'https://www.facebook.com/share/1AeNGhTwwz/?mibextid=wwXIfr' },
            ].map((social) => (
              <a
                key={social.icon}
                href={social.href}
                rel="nofollow noreferrer"
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-yellow-600/30 text-gray-400 hover:border-yellow-500 hover:text-yellow-400 transition-all duration-300 cursor-pointer"
              >
                <i className={`${social.icon} text-lg`} />
              </a>
            ))}
          </div>
          <p
            className="text-gray-600 text-xs text-center"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            © 2026 Filmodeling · Via Raffaele Viviani 7, Pozzuoli ·{' '}
            <Link to="/privacy-policy" rel="nofollow" className="underline hover:text-yellow-500 transition-colors cursor-pointer">
              Privacy Policy
            </Link>
          </p>
        </footer>
      </div>
    </section>
  );
}
